import { Bot, Loader2 } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div
      className="h-screen flex flex-col items-center justify-center bg-[#09090b] gap-4"
      role="status"
      aria-label="Loading"
      aria-live="polite"
      data-testid="loading-screen"
    >
      <div className="w-12 h-12 rounded-xl bg-emerald-500 flex items-center justify-center">
        <Bot className="w-7 h-7 text-emerald-950" />
      </div>
      <Loader2 className="w-5 h-5 text-emerald-500 animate-spin" />
      <p className="text-sm text-zinc-500">Loading Agentick...</p>
    </div>
  );
}
